export function saveFile (text: string, name: string, type: string) {
  let dummyLink = document.createElement("a")
  const file = new Blob([text], {type})
  dummyLink.href = URL.createObjectURL(file)
  dummyLink.download = name
  dummyLink.click()
}



// WEBPACK FOOTER //
// ./src/lib/saveFile.ts